import { render, staticRenderFns } from "./PostProgressBar.vue?vue&type=template&id=54dde201&scoped=true&"
import script from "./PostProgressBar.vue?vue&type=script&lang=js&"
export * from "./PostProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./PostProgressBar.vue?vue&type=style&index=0&id=54dde201&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dde201",
  null
  
)

export default component.exports